import { Link } from "react-router-dom";
import UsePermissionsClaim from "../../CustomHooks/UsePermissionsClaim";

const ModuleContent = ({ moduleTitle, moduleIcon, route, permission }) => {
  const { checkPermission } = UsePermissionsClaim();
  const hasPermission = permission ? checkPermission(permission) : true;

  return (
    <>
      <Link
        className={`homeModule-link ${hasPermission ? "" : "pointer-events-none"}`}
        to={route || "#"}
      >
        <div className="homeModule-wrap">
          <div
            className={`rounded-md bg-lb3 ${hasPermission ? "shadow-sh-2" : ""}`}
          >
            <div className="homeModule-wrap-img">
              <img
                src={moduleIcon}
                alt="moduleIcon"
                className="homeModule-img"
              />
            </div>
            <div
              className={`homeModule-title ${hasPermission ? "shadow-sh-2" : ""}`}
            >
              {moduleTitle}
            </div>
          </div>
        </div>
      </Link>
    </>
  );
};

export default ModuleContent;
